import type { RDMDProps } from '@readme/backend/iso';
import type React from 'react';

interface DehydratedProps {
  className?: string;
  'data-testid'?: string;
  string?: string;
  style?: React.CSSProperties;
  Tag?: RDMDProps['Tag'];
}

const Dehydrated = ({ className, 'data-testid': dataTestId, string = '', style, Tag = 'div' }: DehydratedProps) => (
  <Tag className={className} data-testid={dataTestId} dangerouslySetInnerHTML={{ __html: string }} style={style} />
);

export default Dehydrated;
